import { useEffect } from "react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
    filtersValue,
    isLoadingFilters,
    isLoadingTable,
    isLoadingStats,
    tableData,
    totalCount,
    statsData,
    selectedRows
} from "../@signals"


export default function useSkuCandidates() {
    const { showToast } = useAppToast()

    const fetchCandidates = () => {
        isLoadingTable.value = true
        tableData.value = []
        selectedRows.value = []

        postSubmit(`${BACKEND_APIS.SKU_CANDIDATES}/search`, filtersValue.value)
            .then(res => {
                if (res) {
                    tableData.value = res.data || []
                    totalCount.value = res.total || 0
                }
            })
            .catch(() => showToast.error('Error loading candidates'))
            .finally(() => {
                isLoadingTable.value = false
                isLoadingFilters.value = false
            })
    }

    const fetchStats = () => {
        isLoadingStats.value = true

        postSubmit(`${BACKEND_APIS.SKU_CANDIDATES}/stats`, filtersValue.value)
            .then(res => {
                if (res) {
                    statsData.value = res
                }
            })
            .catch(() => console.error('Error loading stats'))
            .finally(() => {
                isLoadingStats.value = false
            })
    }

    // Trigger search when filters are submitted
    useEffect(() => {
        if (isLoadingFilters.value) {
            fetchCandidates()
            fetchStats()
        }
    }, [isLoadingFilters.value])

    return {
        isLoading: isLoadingTable.value,
        data: tableData.value,
        total: totalCount.value,
        refetch: fetchCandidates
    }
}
